import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_ClaimType_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_CLMTYPE_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Claim Type WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    CLAIM_TYPE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Type Id', columnResourceName: 'colClaimTypeId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CLAIM_TYPE_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Type Name', columnResourceName: 'colClaimTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CLAIM_TYPE_COMMENTS: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Comments', columnResourceName: 'colClaimTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1333}},
    TREE_PATH:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tree Path', columnResourceName: 'colClaimTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    BUSINESSUNIT_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Business Unit Id', columnResourceName: 'colClaimTypeId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    BUSINESSUNIT_NAME:   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Business Unit', columnResourceName: 'colClaimTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const ClaimTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_CLMTYPE_ID',
                id_ui: 'CLAIM_TYPE_ID',
                name:  'CLAIM_TYPE_NAME'},


    searchProviderFields: vUI_ClaimType_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_ClaimType_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


const ClaimTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "ClaimTypeSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'CLAIM_TYPE_ID', renderOptions: { }},
        {profileFilterName: 'Name',   searchProviderFieldId: 'CLAIM_TYPE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'CLAIM_TYPE_ID','CLAIM_TYPE_NAME', 'BUSINESSUNIT_NAME', 'CLAIM_TYPE_COMMENTS',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ClaimTypeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const ClaimTypeSearch: ISearch = {
    searchName: "Find Claim Type",
    renderOptions: { ui5ResourceId: "ClaimTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ClaimTypeSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("ClaimTypeBO", "ClaimType", ClaimTypeSearch, "Claim Type Search")

export {ClaimTypeSearch}